import { ScheduleConfirmationStatuses, ScheduleStatuses } from '../constants/Schedule';

function getHumanScheduleStatus(status, isTakenOver, isSelfShowing = false, assignedAgentId = null) {
  const hasAgent = !!assignedAgentId;
  let statusInHumanFormat = '';
  switch (status) {
    case ScheduleStatuses.STATUS_SCHEDULED:
      statusInHumanFormat = isSelfShowing ? 'Self-showing' : 'Scheduled';
      break;
    case ScheduleStatuses.STATUS_IS_AUTO_DELETED:
      statusInHumanFormat = 'No agent found';
      break;
    case ScheduleStatuses.STATUS_ABOUT_TO_EXPIRE:
      statusInHumanFormat = 'About to expire';
      break;
    case ScheduleStatuses.STATUS_LOOKING_FOR_AGENT:
      statusInHumanFormat = 'Looking for agent';
      break;
    case ScheduleStatuses.STATUS_SCHEDULED_TAKEN_OVER:
      statusInHumanFormat = 'Taken Over';
      break;
    case ScheduleStatuses.STATUS_PENDING:
      if (isSelfShowing) {
        statusInHumanFormat = 'Self-showing';
      } else if (hasAgent) {
        statusInHumanFormat = 'Scheduled - Agent Matched';
      } else {
        statusInHumanFormat = 'Scheduled';
      }
      break;
    case ScheduleStatuses.STATUS_COMPLETED:
      statusInHumanFormat = 'Completed';
      if (isTakenOver) {
        statusInHumanFormat += ' - Taken Over';
      }
      if (isSelfShowing) {
        statusInHumanFormat += ' - Self-showing';
      }
      break;
    case ScheduleStatuses.STATUS_NO_SHOW:
      statusInHumanFormat = isTakenOver ? 'No show - Taken Over' : 'No show';
      break;
    case ScheduleStatuses.STATUS_TIME_OUT:
      statusInHumanFormat = 'Missing Report - Self-showing';
      break;
    case ScheduleStatuses.STATUS_TECHNICAL_ISSUE:
      statusInHumanFormat = isTakenOver ? 'Technical Issue - Taken Over' : 'Technical Issue';
      break;
    case ScheduleStatuses.STATUS_CANCELLED_SURRENDERED:
      statusInHumanFormat = 'Cancelled (Surrendered)';
      break;
    case ScheduleStatuses.STATUS_CANCELLED_BY_ADMIN:
      statusInHumanFormat = 'Cancelled by admin';
      break;
    case ScheduleStatuses.STATUS_CANCELLED_BY_AGENT:
      statusInHumanFormat = 'Cancelled by agent';
      break;
    case ScheduleStatuses.STATUS_CANCELLED_BY_LEAD:
      statusInHumanFormat = 'Cancelled by lead';
      break;
    case ScheduleStatuses.STATUS_CANCELLED_BY_PM:
      statusInHumanFormat = 'Cancelled by pm';
      break;
    case ScheduleStatuses.STATUS_CANCELLED_BY_PM_TECHNICAL_ISSUE:
      statusInHumanFormat = 'Cancelled By Technical Issue';
      break;
    case ScheduleStatuses.STATUS_CANCELLED_BY_PM_OTHER:
      statusInHumanFormat = 'Cancelled Other';
      break;
    case ScheduleStatuses.STATUS_CANCELLED_RESCHEDULED:
      statusInHumanFormat = 'Cancelled - rescheduled';
      break;
    case ScheduleStatuses.STATUS_CANCELLED_NO_LEAD_CONFIRMATION:
      statusInHumanFormat = 'Cancelled - no lead confirmation';
      break;
    case ScheduleStatuses.STATUS_CANCELLED_SHOWING_STOPPED:
      statusInHumanFormat = 'Cancelled - deactivated';
      break;
    case ScheduleStatuses.STATUS_CANCELLED_SHOWING_PAUSED:
      statusInHumanFormat = 'Cancelled - showings paused';
      break;
    case ScheduleStatuses.STATUS_CANCELLED_SHOWING_WINDOWS_CHANGED:
      statusInHumanFormat = 'Cancelled - showing windows changed';
      break;
    case ScheduleStatuses.STATUS_CANCELLED_BY_LEAD_RESCHEDULED:
      statusInHumanFormat = 'Cancelled by lead - rescheduled';
      break;
  }
  return statusInHumanFormat;
}

function getHumanConfirmationStatus(status) {
  let statusInHumanFormat = '';
  switch (status) {
    case ScheduleConfirmationStatuses.CONFIRMATION_STATUS_CONFIRMED:
      statusInHumanFormat = 'Confirmed';
      break;
    case ScheduleConfirmationStatuses.CONFIRMATION_STATUS_NOT_CONFIRMED:
      statusInHumanFormat = 'Requires confirmation';
      break;
    case ScheduleConfirmationStatuses.CONFIRMATION_STATUS_NOT_REQUIRED:
      statusInHumanFormat = 'Not required';
      break;
    case ScheduleConfirmationStatuses.CONFIRMATION_STATUS_WAITING_FOR_CONFIRMATION:
      statusInHumanFormat = 'Waiting for confirmation';
      break;
  }
  return statusInHumanFormat;
}

export { getHumanConfirmationStatus, getHumanScheduleStatus };
